<template>
    <div v-if="clearAll">
        <p class="head">Purchase additional kits at a discounted price</p>
        <div class="content-tab-container">
                <div v-for="(store, index) in (filteredStoreList('Kit', 'Digital upgrade') ? filteredStoreList('Kit', 'Digital upgrade').filter(store => !store.purchased) : [])" :key="index">
                <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4>{{ store.title }}</h4>
                    <p class="price">
                        {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                    </p>
                </div>
                <div class="card-hover-content">
                    <div class="card-content-hover">
                        <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                        <img :src="Bg1" v-else class="w-65" />
                        <div>
                            <h4>{{ store.title }}</h4>
                            <p class="price">
                                {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                            </p>
                        </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.shortDescription"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }"
                        class="explore-btn">Explore</router-link>
                </div>
            </div>
        </div>

        <!-- Merchandise -->
        <p class="head">Unlock more of your DNA story.</p>
        <div class="content-tab-container">
            <div v-for="(store, index) in filteredStoreList('Merchandise')" :key="index" class="card">
                <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4>{{ store.title }}</h4>
                    <p class="price">
                        {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                    </p>
                </div>
                <div class="card-hover-content">
                    <div class="card-content-hover">
                        <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                        <img :src="Bg1" v-else class="w-65" />
                        <div>
                            <h4>{{ store.title }}</h4>
                            <p class="price">
                                {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                            </p>
                        </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.shortDescription"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }"
                        class="explore-btn">Explore</router-link>
                </div>
            </div>
        </div>

        <!-- Vitamins supplement -->
        <p class="head">Purchase a vitamin supplement based on your DNA</p>
        <div class="content-tab-container">
            <div v-for="(store, index) in filteredStoreList('Vitamins supplement')" :key="index" class="card">
                <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4>{{ store.title }}</h4>
                    <p class="price">
                        {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                    </p>
                </div>
                <div class="card-hover-content">
                    <div class="card-content-hover">
                        <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                        <img :src="Bg1" v-else class="w-65" />
                        <div>
                            <h4>{{ store.title }}</h4>
                            <p class="price">
                                {{ store?.currencySymbol?.raw }} {{ store?.price?.base }}
                            </p>
                        </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.shortDescription"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }"
                        class="explore-btn">Explore</router-link>
                </div>
            </div>
        </div>

        <!-- Blood Tests -->
        <p v-if="filteredProductList('Blood Test').length > 0" class="head">Blood Tests</p>
        <div class="content-tab-container">
            <div v-for="(store, index) in filteredProductList('Blood Test')" :key="index" class="card">
                <div class="card-content">
                    <img :src="store?.thumbnail_image?.[0]?.url" alt="" class="img-thumbnails"
                        v-if="store?.thumbnail_image?.[0]?.url" />
                    <img :src="Bg6" v-else alt="" />
                    <div>
                        <h4>{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                    </div>
                </div>
                <div class="card-hover-content">
                    <div class="card-content-hover">
                        <img :src="store?.thumbnail_image?.[0]?.url" class="img-thumbnails" alt=""
                            v-if="store?.thumbnail_image?.[0]?.url" />
                        <img :src="Bg6" v-else alt="" />
                        <h4>{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                        <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }"
                            class="active-btn">Order</router-link>
                        <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }"
                            class="blood-btn">Explore</router-link>
                    </div>
                </div>
            </div>
        </div>
        <p class="head">Genetic Reports</p>
        <div class="content-tab-container">
            <div v-for="(store, index) in (productStoreList || []).filter(item => item.product_type === 'Genetic Test')"
                :key="index" class="card">

                <div class="card-content">
                    <img :src="store?.thumbnail_image?.[0]?.url" alt="" class="img-thumbnails"
                        v-if="store?.thumbnail_image?.[0]?.url" />
                    <img :src="Bg6" v-else alt="" />
                    <div>
                        <h4>{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                    </div>
                </div>
                <div class="card-hover-content">
                    <div class="card-content-hover">
                        <img :src="store?.thumbnail_image?.[0]?.url" class="img-thumbnails" alt=""
                            v-if="store?.thumbnail_image?.[0]?.url" />
                        <img :src="Bg6" v-else alt="" />
                        <h4>{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                        <!-- A genetic report is a digital upgrade: AncestryDetails sells it with no
                             delivery address, at the store region's price. -->
                        <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }"
                            class="active-btn">Order</router-link>
                        <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }"
                            class="blood-btn">Explore</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        combinedStoreList: {
            type: Array,
            required: true,
        },
        productStoreList: {
            type: Array,
            required: true,
        },
        clearAll: {
            type: Boolean,
            required: true,
        },
        Bg1: {
            type: String,
            required: true,
        },
        Bg6: {
            type: String,
            required: true,
        },
    },
    methods: {
        filteredStoreList(...categories) {
            return (this.combinedStoreList || []).filter((item) =>
                categories.includes(item.categories)
            );
        },
        filteredProductList(productType) {
            return (this.productStoreList || []).filter(
                (item) => item.product_type === productType
            );
        },
    },
};
</script>

<style scoped>
/* Add your styles here */
</style>
